export default "__VITE_ASSET__45007c72__"